import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import { UserGroup } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';

export function UserGroupDetailsForm(props: { userGroup?: UserGroup; onSaved?: () => void }) {
  const [loading, setLoading] = useState(false);

  const onEditFinish = (values: any) => {
    setLoading(true);
    apiClient
      .put(`user-groups/${props.userGroup?.id}`, values)
      .then(() => {
        setLoading(false);
        if (props.onSaved) {
          props.onSaved();
        }
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  return (
    <Form layout="vertical" onFinish={onEditFinish} initialValues={props.userGroup}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { pattern: /^[a-zA-Z0-9ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/, message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir' },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Açıklama"
        name="description"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 400, message: 'En fazla 400 karakter' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Kaydet
        </Button>
      </Form.Item>
    </Form>
  );
}
